// extracted by mini-css-extract-plugin
export var askAiIcon = "_oq-9";
export var container = "_oq-0";
export var groupSeparator = "_oq-a";
export var highlight = "_oq-4";
export var resultIcon = "_oq-5";
export var resultItem = "_oq-7";
export var resultSubtitle = "_oq-3";
export var resultTitle = "_oq-2";
export var resultsList = "_oq-1";
export var searchGroup = "_oq-6";
export var selected = "_oq-8";